export default __webpack_public_path__ + "static/media/september2024-4.1c544d7a.jpg";